/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsCreate } from "../../funcs/authTeamsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateTeamRequest$inboundSchema,
};

export const tool$authTeamsCreate: ToolDefinition<typeof args> = {
  name: "auth-teams-create",
  description: `Create a team`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
